import { filterStateApiConnector } from 'apiConnector/blotters';
import { ofType } from 'redux-observable';
import { EMPTY, of } from 'rxjs';
import { catchError, filter, map, mergeMap, take, withLatestFrom } from 'rxjs/operators';
import { showNotificationThunk } from 'state/notifications/notification.thunk';
import type { EpicWithThunk } from 'state/state.common';
import {
  addonManagementFiltersLoaded,
  addonManagementFiltersLoadingFailed,
  addonManagementFiltersPersistenceFailed,
} from 'state/workspaces/addonManagement/addonManagement.actions';
import type { AddonManagementFilters } from 'state/workspaces/addonManagement/addonManagement.model';

import { isNavigatingInAddonManagement } from '../../../utils/navigation/navigation';
import { toFilterState } from './filterStateEpics.helper';

export function persistFilterStateEpic(): EpicWithThunk {
  return (action$, state$, { httpClient, selectors: { getAddonManagementWorkspaceFiltersToPersist } }) =>
    action$.pipe(
      ofType('ADDON_MANAGEMENT_FILTER_CHANGED'),
      withLatestFrom(state$),
      mergeMap(([_, state]) => {
        const filters: AddonManagementFilters = {
          ...getAddonManagementWorkspaceFiltersToPersist(state),
          issueDateOnAndAfter: undefined,
        };
        return filterStateApiConnector(httpClient)
          .saveState(filters, 'addonManagement')
          .pipe(
            mergeMap(_ => EMPTY),
            catchError(() => {
              return of(addonManagementFiltersPersistenceFailed());
            }),
          );
      }),
    );
}

export function loadFilterStateEpic(): EpicWithThunk {
  return (actions$, state$, { httpClient }) => {
    return actions$.pipe(
      filter(isNavigatingInAddonManagement),
      withLatestFrom(state$),
      take(1),
      mergeMap(() => {
        return filterStateApiConnector(httpClient)
          .getState('addonManagement')
          .pipe(
            map(response => addonManagementFiltersLoaded(toFilterState(response))),
            catchError(() => {
              return of(
                addonManagementFiltersLoadingFailed(),
                showNotificationThunk({
                  level: 'warning',
                  title: { id: 'toast.internalError' },
                  content: [{ id: 'addonManagement.loadSavedFiltersError' }],
                }),
              );
            }),
          );
      }),
    );
  };
}
